module.exports = __webpack_public_path__ + "55bdaa077e7b42288498f657deda334c.jpg";